<template>
  <v-container class="mt-2">
    <v-card class="px-2 pb-2">
      <v-row>
        <v-col>
          <p>Regra de Aceitação - Editar</p>
        </v-col>
        <v-col cols="3" class="d-flex flex-row justify-end">
          <v-btn small @click="update">
            <v-icon small title="Create">fas fa-save</v-icon>
          </v-btn>
          <v-btn class="ml-1" small @click="$refs.form.goBack()">
            <v-icon small title="Voltar">fas fa-arrow-circle-left</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-divider class="mb-4"></v-divider>

      <v-skeleton-loader
          v-if="!acceptanceRule"
          type="article, actions"
      ></v-skeleton-loader>

      <v-container fluid>
        <AcceptanceRuleForm ref="form" :errors="errors" :acceptance-rule="acceptanceRule" v-if="acceptanceRule"></AcceptanceRuleForm>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import AcceptanceRuleForm from "@/view/acceptance_rule/_acceptance_rule_form"
import {mapErrors} from "@/common/validation"
import {mapActions, mapMutations} from "vuex";

export default {
  components: { AcceptanceRuleForm },
  data() {
    return {
      errors: {},
      acceptanceRule: null
    };
  },
  async created() {
    this.acceptanceRule = await this.fetchAcceptanceRule(this.$route.params.id);
    this.isLoading = false;
  },
  methods: {
    ...mapActions("acceptanceRule", ["fetchAcceptanceRule", "updateAcceptanceRule"]),
    ...mapMutations(["toogleDialogLoading"]),
    update() {
      this.toogleDialogLoading(true);
      this.errors = {}

      this.updateAcceptanceRule({id: this.acceptanceRule.id, acceptanceRule: this.$refs.form.model()})
          .then((data) => {
            this.$router.push(`/acceptance_rule/${data.id}/show`)
          })
          .catch((error) => {
            const { errors } = error.response.data;
            this.errors = mapErrors(this.$refs.form.model(), errors)
          })
          .finally(() => {
            this.toogleDialogLoading(false);
          });
    }
  },
};
</script>


